export default {
  button: "How to?",
  product_creation: "How to create a product and collection:",
  menu_items: "How to edit your store menu:",
}
